import { addCLinkerToUrl } from '../cLinkerUtils';

const getEcommLinkWithWalletData = (
    href = '',
    ecommercePaymentsInfo = {},
    userZip = '',
    baseUrl = '',
    dealerId = null,
    chatSessionId = null
) => {
    const queryParams = {
        ...ecommercePaymentsInfo,
        mw_z: userZip,
    };

    const dealerIdKey = 'dealerId';

    if (baseUrl) {
        queryParams.url = encodeURI(baseUrl);
    }

    // Add chat session ID if available
    if (chatSessionId) {
        queryParams.chatSessionId = chatSessionId;
    }

    try {
        const url = new URL(href);

        Object.entries(queryParams).forEach(([key, value]) => value != null && url.searchParams.append(key, value));
        if (dealerId && !url.searchParams.has(dealerIdKey)) url.searchParams.append(dealerIdKey, dealerId);
        if (url.hash) url.hash += (url.hash.includes('?') ? '&' : '?') + url.searchParams.toString();

        // Add CLinker for cross-domain tracking
        const urlWithCLinker = addCLinkerToUrl(url.toString());
        return urlWithCLinker;
    } catch {
        return href;
    }
};

export default getEcommLinkWithWalletData;
